// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var LlmModel$ReactHooksTemplate = require("./llmModel.res.js");

function emptyProvider(param) {
  return {
          id: undefined,
          name: "",
          authType: "",
          endpoint: "",
          apiKey: undefined,
          authConfig: {},
          models: /* [] */0
        };
}

function id(t) {
  return t.id;
}

function name(t) {
  return t.name;
}

function authType(t) {
  return t.authType;
}

function endpoint(t) {
  return t.endpoint;
}

function apiKey(t) {
  return t.apiKey;
}

function models(t) {
  return t.models;
}

function authConfig(t) {
  return t.authConfig;
}

function setId(t, id) {
  return {
          id: id,
          name: t.name,
          authType: t.authType,
          endpoint: t.endpoint,
          apiKey: t.apiKey,
          authConfig: t.authConfig,
          models: t.models
        };
}

function setName(t, name) {
  return {
          id: t.id,
          name: name,
          authType: t.authType,
          endpoint: t.endpoint,
          apiKey: t.apiKey,
          authConfig: t.authConfig,
          models: t.models
        };
}

function setAuthType(t, authType) {
  return {
          id: t.id,
          name: t.name,
          authType: authType,
          endpoint: t.endpoint,
          apiKey: t.apiKey,
          authConfig: t.authConfig,
          models: t.models
        };
}

function setEndpoint(t, endpoint) {
  return {
          id: t.id,
          name: t.name,
          authType: t.authType,
          endpoint: endpoint,
          apiKey: t.apiKey,
          authConfig: t.authConfig,
          models: t.models
        };
}

function setApiKey(t, apiKey) {
  return {
          id: t.id,
          name: t.name,
          authType: t.authType,
          endpoint: t.endpoint,
          apiKey: apiKey,
          authConfig: t.authConfig,
          models: t.models
        };
}

function setModels(t, models) {
  return {
          id: t.id,
          name: t.name,
          authType: t.authType,
          endpoint: t.endpoint,
          apiKey: t.apiKey,
          authConfig: t.authConfig,
          models: models
        };
}

function setAuthConfig(t, authConfig) {
  return {
          id: t.id,
          name: t.name,
          authType: t.authType,
          endpoint: t.endpoint,
          apiKey: t.apiKey,
          authConfig: authConfig,
          models: t.models
        };
}

function fromJson(json) {
  return {
          id: Json_decode.field("id", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          name: Json_decode.field("name", Json_decode.string, json),
          authType: Json_decode.field("auth_type", Json_decode.string, json),
          endpoint: Json_decode.field("api_endpoint", Json_decode.string, json),
          apiKey: undefined,
          authConfig: Json_decode.field("auth_config", (function (param) {
                  return Json_decode.dict(Json_decode.string, param);
                }), json),
          models: Json_decode.field("llm_models", (function (param) {
                  return Json_decode.list(LlmModel$ReactHooksTemplate.decodeModels, param);
                }), json)
        };
}

function toJson(t) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "name",
                  t.name
                ],
                tl: {
                  hd: [
                    "auth_type",
                    t.authType
                  ],
                  tl: {
                    hd: [
                      "auth_config",
                      Json_encode.dict((function (prim) {
                              return prim;
                            }), t.authConfig)
                    ],
                    tl: {
                      hd: [
                        "api_endpoint",
                        t.endpoint
                      ],
                      tl: {
                        hd: [
                          "api_key",
                          Json_encode.nullable((function (prim) {
                                  return prim;
                                }), t.apiKey)
                        ],
                        tl: {
                          hd: [
                            "llm_models_attributes",
                            Json_encode.list(LlmModel$ReactHooksTemplate.encodeModel, t.models)
                          ],
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }
            });
}

exports.id = id;
exports.name = name;
exports.authType = authType;
exports.authConfig = authConfig;
exports.endpoint = endpoint;
exports.apiKey = apiKey;
exports.models = models;
exports.emptyProvider = emptyProvider;
exports.fromJson = fromJson;
exports.toJson = toJson;
exports.setId = setId;
exports.setName = setName;
exports.setAuthType = setAuthType;
exports.setAuthConfig = setAuthConfig;
exports.setEndpoint = setEndpoint;
exports.setApiKey = setApiKey;
exports.setModels = setModels;
/* No side effect */
